import "./AdminDash.scss";
import RightDash from "../../components/RightDash/RightDash";
import { Link } from "react-router-dom";
import LeftDash from "../../components/LeftDash/LeftDash";

const AdminDash = () => {
  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location = "/login";
  };
  return (
    <div className="admin-dash">
      <h1 className="admin-dash__title">DASHBOARD</h1>
      <div className="admin-dash__container">
        <Link to="/admin/upload" className="admin-dash__link">
          <LeftDash />
        </Link>
        <Link to="/admin/request" className="admin-dash__link">
          <RightDash />
        </Link>
      </div>
      <button className="admin-dash__button" onClick={handleLogout}>
        LOGOUT
      </button>
    </div>
  );
};

export default AdminDash;
